import React from 'react';

function CondensedNotes({ row, slicedIndex }){
    const slicedString = row.value.slice(0, slicedIndex)
    const [readMore, setReadMore] = React.useState(false)
    const [readLess, setReadLess] = React.useState(false)
    React.useEffect(() => {
        if(row.value.length > 200){
            setReadMore(true)
            setReadLess(true)
        }
    }, [row])
    if(readMore){
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        return <>{slicedString}<a role="button" onClick={() => setReadMore(false)} style={{color: "green"}}>...Read More</a></>
    }
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return <>{row.value}{readLess && <a role="button" onClick={() => setReadMore(true)} style={{color: "green"}}>...Read Less</a>}</>
}

export default CondensedNotes;